<div class="py-5">
    <div class="d-flex">
        <div class="col-12" *ngIf="exportFile">
            <div class="float-end">
                <button class="btn btn-md btn-info text-light" (click)="exportData()">Exportar Excel</button>
                <button
                    *ngFor="let item of botones || []"
                    class="mx-2 btn btn-md text-light"
                    [ngClass]="item.css"
                    (click)="item.accion()"
                >
                    {{ item.texto }}
                </button>
            </div>
        </div>
    </div>
    <table #table datatable [dtOptions]="dtOptions" class="row-border hover" aria-describedby="table">
        <thead>
            <tr>
                <th scope="col" [sortable]="item.key" (sort)="onSort($event)"
                    *ngFor="let item of mapHeader | keyvalue : compare">
                    {{ getDisplay(item.value) }}
                </th>
            </tr>
        </thead>
        <tbody>
        </tbody>
    </table>
</div>
